import { render, staticRenderFns } from "./ThankyouGame.vue?vue&type=template&id=67516654&scoped=true"
import script from "./ThankyouGame.vue?vue&type=script&lang=js"
export * from "./ThankyouGame.vue?vue&type=script&lang=js"
import style0 from "./ThankyouGame.vue?vue&type=style&index=0&id=67516654&prod&scoped=true&lang=css"
import style1 from "./ThankyouGame.vue?vue&type=style&index=1&id=67516654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67516654",
  null
  
)

export default component.exports